import { scan, to_array } from "@pdfking/rfunc"
import { IsNull } from "@pdfking/tfunc"
import fire_event from "@pdfking/workflow/utils/fire_event"
import { startswith } from "@pdfking/workflow/utils/strings"
import { add_get_param, url_parse } from "@pdfking/workflow/utils/urlutilities"
import new_file_from_datatransfer from "src/files/make/new_file_from_datatransfer"
import closest from "../dom/closest"
import confirm from "../dom/confirm"
import on from "../dom/on"
import selector from "../dom/selector"
import toggle_class from "../dom/toggle_class"
import check_url_is_ajax from "../navigation/check_url_is_ajax"
import register_dom_update from "../navigation/register_dom_update"
import start_request from "../navigation/start_request"
import get_router from "../routes/router"
import state from "../state/main"
import storage from "../state/storage"
import user from "../state/user"
import form_to_query_string from "../utils/form_to_query_string"
import scroll_to from "../utils/scroll_to"
import { dismiss_dropdowns } from "./bootstrap"

const FORM_PREFIX = "form:not([rel~=disable-ajax-nav])"

function full_path(l) {
  return l.pathname + l.search
}

function can_do_ajax(e) {
  // check if the user is pressing left button and is not holding command key
  return e.which == 1 && !(e.metaKey && !e.ctrlKey)
}

function update_link_query_string(href, extra) {
  const url = url_parse(href)
  url.search = window.location.search
  if (extra) {
    if (url.search) {
      url.search += `&${extra}`
    } else {
      url.search = extra
    }
  }
  return url.href
}

function update_link_path(href) {
  const win = window.location
  const cur = url_parse(href)
  cur.pathname = win.pathname
  cur.search = win.search
  cur.hash = win.hash

  return cur.href
}

on("click", "a", async (target, event) => {
  if (
    target.matches(
      "[data-slide-modal],.dropdown-toggle,.bootstrap-dropdown,.pdfviewlink"
    )
  ) {
    if (target.matches(".pdfviewlink")) {
      // @ts-expect-error TS2554
      dismiss_dropdowns()
    }

    event.preventDefault()
    event.stopPropagation()
    return false
  }

  // @ts-expect-error TS2339
  if (closest(target, ".markdown") && !check_url_is_ajax(target.href)) {
    // @ts-expect-error TS2339
    target.target = "_blank"
  }

  if (target.matches("[data-update-search]")) {
    // @ts-expect-error TS2339
    target.href = update_link_query_string(
      // @ts-expect-error TS2339
      target.href,
      target.getAttribute("data-update-search")
    )
  }

  if (target.matches("[data-update-path]")) {
    // @ts-expect-error TS2339
    target.href = update_link_path(target.href)
  }

  if (target.matches(".updatenext")) {
    // @ts-expect-error TS2339
    target.href = add_get_param(target.href, {
      next: full_path(window.location),
    })
  }

  // @ts-expect-error TS2339
  state.track_event(
    target.getAttribute("data-track-event") || "link",
    target.getAttribute("data-track-type") ||
      // @ts-expect-error TS2339
      (check_url_is_ajax(target.href) ? "internal" : "external")
  )

  if (
    target.matches(
      "a:not([rel~=disable-ajax-nav]):not([data-toggle~=dropdown]):not([target=_blank]):not([data-slide-modal])"
    )
  ) {
    const message = target.getAttribute("data-confirm")

    if (message) {
      event.preventDefault()
    }

    if ((message && (await confirm(message))) || !message) {
      const href = target.getAttribute("href")

      // @ts-expect-error TS2339
      if (target.target == "null") {
        event.preventDefault()
        // @ts-expect-error TS2339
        fetch(target.href)
      } else if (startswith(href, "#")) {
        event.preventDefault()
        event.stopPropagation()

        if (startswith(href, "#/")) {
          get_router().push(href.slice(1))
        } else {
          scroll_to(href, {
            behavior: "smooth",
            block: "center",
          })
        }
      } else if (
        // @ts-expect-error TS2339
        target.href &&
        can_do_ajax(event) &&
        // @ts-expect-error TS2339
        check_url_is_ajax(target.href)
      ) {
        event.preventDefault()
        // @ts-expect-error TS2339
        start_request(target.href, {
          change_location:
            target.getAttribute("data-change-location") !== "prevent",
          data: null,
          scroll_control:
            target.getAttribute("data-scroll-control") !== "prevent",
        })
      }
    } else {
      event.preventDefault()
    }
  }
  // @ts-expect-error TS2554
  dismiss_dropdowns()
})

on(
  "click",
  [`${FORM_PREFIX} button[type=submit]`, `${FORM_PREFIX} input[type=submit]`],
  target => {
    // @ts-expect-error TS2339
    if (target.name) {
      closest(target, "form").setAttribute(
        "data-form-submit",
        // @ts-expect-error TS2339
        `${target.name}=${target.value || ""}`
      )
    }

    scan(
      (a1, a2) =>
        target.getAttribute(a1)
          ? closest(target, "form").setAttribute(a2, target.getAttribute(a1))
          : null,
      {
        action: "data-form-action",
        method: "data-form-method",
        rel: "rel",
      }
    )
  }
)

on(
  "change",
  [
    "input.submit-onchange",
    "select.submit-onchange",
    "textarea.submit-onchange",
    ".submit-onchange input:not(.prevent-submit-onchange)",
    ".submit-onchange select:not(.prevent-submit-onchange)",
    ".submit-onchange textarea:not(.prevent-submit-onchange)",
  ],
  target => {
    fire_event(closest(target, "form"), "submit")
  }
)

const get_form_url = form =>
  form.getAttribute("data-action") ||
  form.getAttribute("action") ||
  full_path(window.location)

function form_submit(form, e, input) {
  var url = get_form_url(form)

  if (check_url_is_ajax(url)) {
    if (e) e.preventDefault()

    var method = (form.getAttribute("method") || "get").toLowerCase()

    var data = IsNull(input) ? form_to_query_string(form) : input

    if (form.getAttribute("data-form-submit"))
      data = `${form.getAttribute("data-form-submit")}&${data}`

    toggle_class(form, { submitted: true })

    // @ts-expect-error TS2339
    state.track_event("form_submit", form.getAttribute("id") || "form_submit")

    if (method != "post") {
      url = `${url.split("?")[0]}?${data}`
      data = null
    }

    start_request(url, {
      change_location: form.getAttribute("data-change-location") !== "prevent",
      data,
      oncomplete: () => toggle_class(form, { submitted: false }),
      scroll_control: form.getAttribute("data-scroll-control") !== "prevent",
    })
  }
}

// @ts-expect-error TS2554
on("submit", FORM_PREFIX, (form, e) => form_submit(form, e))

on(["dragleave", "drop", "dragend"], null, () =>
  toggle_class(document.body, { "state-drag": false })
)
on("dragover", null, (_t, e) => {
  e.preventDefault()
  toggle_class(document.body, { "state-drag": true })
})
on("drop", null, (_t, e) => {
  // @ts-expect-error TS2339
  if (user.is_staff) {
    e.preventDefault()

    Promise.all(
      // @ts-expect-error
      to_array(e.dataTransfer.files).map(file =>
        new_file_from_datatransfer(file)
      )
      // @ts-expect-error
    ).then(storage.add_files)
  }
})

register_dom_update({
  after: () =>
    scan(
      form =>
        start_request(
          `${get_form_url(form)}?${window.location.search.slice(1)}`,
          {
            change_location: false,
            scroll_control: false,
          }
        ),
      selector("[data-product-cached=true]")
    ),
})
